// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import {InjectionToken} from '@angular/core';


export const environment = {
  production: false,
  defaultAuth: 'fakebackend',
  commitHash: '9e860a3',
  commitDate: 'Thu Oct 22 00:37:11 2026 -0500',
  deployDate: '2026-10-22T05:37:33Z',
  apiUrl: 'http://localhost:8080',
  formsUrl: "http://localhost:4300",
  appVersion: 'local-dev',
  // Local dev: empty DSN disables Sentry entirely (no-op).
  // The Sentry "environment" tag is derived at runtime from window.location.hostname
  // in src/main.ts, so we don't need to plumb it through here.
  sentry: {
    dsn: '',
    tracesSampleRate: 0,
  },
  firebaseConfig: {
    apiKey: "AIzaSyCqS9cSPrDCNSQ-Ku2kZf5DBWjPPv7hvcA",
    authDomain: "test-demo-774f8.firebaseapp.com",
    databaseURL: "https://test-demo-774f8-default-rtdb.firebaseio.com",
    projectId: "test-demo-774f8",
    storageBucket: "test-demo-774f8.appspot.com",
    messagingSenderId: "916438010670",
    appId: "1:916438010670:web:c70cf404da6c0fe7b048bf",
    measurementId: "G-1N6FB2GG55"
  }
};


export const API_VERSION = new InjectionToken<string>('1');


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
